import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { fetchShifts, addShiftPromoter } from '../actions/shifts'
import { fetchPromoters } from '../actions/promoters'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import ShiftEntryList from '../components/ShiftEntryList'
import ShiftsFilterForm from '../forms/ShiftsFilterForm'
import '../styles/MachinesAdminView.css'

class ShiftsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      addModal: false,
      addForm: {
        workerName: '',
        action: 'START',
        date: ''
      },
      addError: null
    }

    this.toggleAddModal = this.toggleAddModal.bind(this)
    this.handleAddFormChange = this.handleAddFormChange.bind(this)
    this.handleAddSubmit = this.handleAddSubmit.bind(this)
  }

  toggleAddModal() {
    this.setState(prev => ({
      addModal: !prev.addModal,
      addError: null,
      addForm: { workerName: '', action: 'START', date: '' }
    }))
  }

  handleAddFormChange(e) {
    const { name, value } = e.target
    this.setState(prev => ({
      addForm: { ...prev.addForm, [name]: value }
    }))
  }

  handleAddSubmit(e) {
    e.preventDefault()
    const { addForm } = this.state
    if (!addForm.workerName || !addForm.date) {
      this.setState({ addError: 'Por favor rellena todos los campos.' })
      return
    }
    const dateUTC = addForm.date ? addForm.date + ':00.000Z' : ''
    this.props.addShiftPromoter({ ...addForm, date: dateUTC })
      .then(response => {
        if (response && response.error) {
          this.setState({ addError: response.error.message })
        } else {
          this.toggleAddModal()
          const today = new Date().toISOString().substring(0, 10)
          this.props.fetchShifts('', '', today, today)
        }
      })
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    this.props.fetchShifts('', '', today, today)
    this.props.fetchPromoters('', 'ALTA')
  }

  renderShifts() {
    const { shifts, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!Array.isArray(shifts) || loading) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    return (<ShiftEntryList shifts={shifts} />)
  }

  renderStartHour(name, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!Array.isArray(shifts) || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let initHour = "None";

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return (shift.workerName).replace(/\s/g, '') === name.replace(/\s/g, '') && shiftDay === day;
    });

    filteredShifts.forEach((shift) => {
      if ((shift.workerName).replace(/\s/g, '') === name.replace(/\s/g, '')) {
        const shiftDate = new Date(shift.date);
        initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
      }
    });

    return initHour;
  }

  renderFinishHour(name, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!Array.isArray(shifts) || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let finishHour = "None";
    let done = false;
    let counter = 0;

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return (shift.workerName).replace(/\s/g, '') === name.replace(/\s/g, '') && (day ? shiftDay === day : true);
    });

    filteredShifts.forEach((shift) => {
      if (!done) {
        const shiftDate = new Date(shift.date);
        finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
        done = true;
      }
    });

    filteredShifts.forEach((shift) => {
      counter++;
    });

    if (counter === 1) {
      finishHour = "None";
    }

    return finishHour;
  }

  renderTotalHour(name, rest, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!Array.isArray(shifts) || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let initHour = "None";
    let finishHour = "None";
    let done = false;
    let counter = 0;

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return (shift.workerName).replace(/\s/g, '') === name.replace(/\s/g, '') && (day ? shiftDay === day : true);
    });

    filteredShifts.forEach((shift) => {
      const shiftDate = new Date(shift.date);
      initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
    });

    filteredShifts.forEach((shift) => {
      if (!done) {
        const shiftDate = new Date(shift.date);
        finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });

        done = true;
      }
    });

    filteredShifts.forEach((shift) => {
      counter++;
    });

    if (counter === 1) {
      finishHour = "None";
    }

    let totalHours = "None";

    if (initHour !== "None" && finishHour !== "None") {
      // Parse the time strings into Date objects
      const initTime = new Date(`2000-01-01 ${initHour}`);
      const finishTime = new Date(`2000-01-01 ${finishHour}`);

      // Calculate the time difference in milliseconds
      let timeDiff = finishTime - initTime;

      // Subtract rest time if rest is provided
      if (rest && typeof rest === 'number') {
        timeDiff -= rest * 60 * 1000; // Convert rest time to milliseconds
      }

      // Convert the time difference to hours and minutes
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const totalMinutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

      // Ensure minutes are always represented by at least two digits
      const minutes = totalMinutes.toString().padStart(2, '0');

      totalHours = `${hours}h${minutes}m`;
    }

    return totalHours;
  }

  renderTotalWorkingHours(name, rest, day) {
    const { shifts, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!Array.isArray(shifts) || loading) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    let initHour = "None";
    let finishHour = "None";
    let done = false;
    let counter = 0;
    let timeDiff = 0;

    const filteredShifts = shifts.filter(shift => {
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().split('T')[0]; // Extracting the date part

      return (shift.workerName).replace(/\s/g, '') === name.replace(/\s/g, '') && (day ? shiftDay === day : true);
    });

    filteredShifts.forEach((shift) => {
      const shiftDate = new Date(shift.date);
      initHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });
    });

    filteredShifts.forEach((shift) => {
      if (!done) {
        const shiftDate = new Date(shift.date);
        finishHour = shiftDate.toLocaleTimeString('es-ES', { timeZone: 'UTC', hour12: false });

        done = true;
      }
    });

    filteredShifts.forEach((shift) => {
      counter++;
    });

    if (counter === 1) {
      finishHour = "None";
    }

    if (initHour !== "None" && finishHour !== "None") {
      // Parse the time strings into Date objects
      const initTime = new Date(`2000-01-01 ${initHour}`);
      const finishTime = new Date(`2000-01-01 ${finishHour}`);

      // Calculate the time difference in milliseconds
      timeDiff = finishTime - initTime;

      // Subtract rest time if rest is provided
      if (rest && typeof rest === 'number') {
        timeDiff -= rest * 60 * 1000; // Convert rest time to milliseconds
      }
    }

    return timeDiff;
  }

  renderStatus(name, day) {

    let init = this.renderStartHour(name, day);
    let finish = this.renderFinishHour(name, day);

    if (init !== 'None' && finish !== 'None') {
      return (
        <div className="d-inline-block p-2">
          <div className="badge bg-success">{name}</div>
        </div>
      )
    } else if (init !== 'None') {
      return (
        <div className="d-inline-block p-2">
          <div className="badge bg-warning">{name}</div>
        </div>
      )
    } else {
      return (
        <div className="d-inline-block p-2">
          <div className="badge bg-danger">{name}</div>
        </div>
      )
    }

  }

  getUserRest(rest) {

    switch (rest) {
      case 30: return "30 minutos";
      case 60: return "1 hora";
      default: return "sin descanso";
    }
  }

  renderWorkers() {
    const { shifts, promoters, filteredPromoters, shiftdaysPromoters } = this.props

    if (!shifts || !promoters) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    if (shiftdaysPromoters.length === 0) {
      shiftdaysPromoters.push(new Date().toISOString().split('T')[0]);

    }

    let usersToRender = filteredPromoters.length > 0 ? filteredPromoters : promoters;

    return (
      <div className="table-responsive shifts-table-wrap">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Trabajador</th>
              <th scope="col">Inicio Jornada</th>
              <th scope="col">Descanso Asignado</th>
              <th scope="col">Fin Jornada</th>
              <th scope="col">Total jornada</th>
            </tr>
          </thead>
          <tbody>
            {shiftdaysPromoters.map(day => (
              <React.Fragment key={day}>
                <tr>
                  <th colSpan="6">{`${day}`}</th>
                </tr>
                {usersToRender.filter(user => user.status === 'ALTA').map(user => (
                  <tr key={user.fullname}>
                    <td>
                      <img
                        className="user-icon m-2"
                        src={`https://vacway-images.s3.eu-central-1.amazonaws.com/${user.fullname}.png`}
                        alt="User"
                        onError={(e) => {
                          e.target.onerror = null; // Prevent infinite loop in case default also fails
                          e.target.src = "https://vacway-images.s3.eu-central-1.amazonaws.com/default.png"; // Default image if user image fails to load
                        }}
                      />
                    </td>
                    <td>{this.renderStatus(user.fullname, day)}</td>
                    <td>{this.renderStartHour(user.fullname, day)}</td>
                    <td>{this.getUserRest(user.rest)}</td>
                    <td>{this.renderFinishHour(user.fullname, day)}</td>
                    <td>{this.renderTotalHour(user.fullname, user.rest, day)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  renderTotalWorkers() {
    const { shifts, promoters, filteredPromoters, shiftdaysPromoters } = this.props

    if (!shifts || !promoters) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    if (shiftdaysPromoters.length === 0) {
      shiftdaysPromoters.push(new Date().toISOString().split('T')[0]);
    }

    let usersToRender = filteredPromoters.length > 0 ? filteredPromoters : promoters;

    let expectedWorkingHours = {};
    let totalWorkingHours = {};
    let statusWorkingHours = {};

    usersToRender.filter(user => user.status === 'ALTA').forEach(user => {
      shiftdaysPromoters.forEach(day => {
        if (!totalWorkingHours[user.fullname]) {
          totalWorkingHours[user.fullname] = 0;
          totalWorkingHours[user.fullname] += this.renderTotalWorkingHours(user.fullname, user.rest, day);
        } else {
          totalWorkingHours[user.fullname] += this.renderTotalWorkingHours(user.fullname, user.rest, day);
        }

        if (!expectedWorkingHours[user.fullname]) {
          expectedWorkingHours[user.fullname] = 0;
          expectedWorkingHours[user.fullname] += ((user.workingday * 60 * 60 * 1000) / 5);
        } else {
          expectedWorkingHours[user.fullname] += ((user.workingday * 60 * 60 * 1000) / 5);
        }
      });

      if (totalWorkingHours[user.fullname] < expectedWorkingHours[user.fullname]) {
        statusWorkingHours[user.fullname] = "bg-danger text-white"
      } else {
        statusWorkingHours[user.fullname] = "bg-success text-white"
      }

      let hours = Math.floor(totalWorkingHours[user.fullname] / (1000 * 60 * 60));
      let totalMinutes = Math.floor((totalWorkingHours[user.fullname] % (1000 * 60 * 60)) / (1000 * 60));

      let minutes = totalMinutes.toString().padStart(2, '0');

      totalWorkingHours[user.fullname] = `${hours}h${minutes}m`;

      hours = Math.floor(expectedWorkingHours[user.fullname] / (1000 * 60 * 60));
      totalMinutes = Math.floor((expectedWorkingHours[user.fullname] % (1000 * 60 * 60)) / (1000 * 60));

      minutes = totalMinutes.toString().padStart(2, '0');

      expectedWorkingHours[user.fullname] = `${hours}h${minutes}m`;
    });

    return (
      <div className="table-responsive shifts-table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Trabajador</th>
              <th scope="col">Jornada Semanal</th>
              <th scope="col">Jornada Esperada</th>
              <th scope="col">Jornada Efectiva</th>
            </tr>
          </thead>
          <tbody>
            {usersToRender.filter(user => user.status === 'ALTA').map(user => (
              <tr
                key={user.fullname}
                className="shifts-colored-row"
                style={{
                  backgroundColor: statusWorkingHours[user.fullname] === 'bg-success text-white' ? '#16a34a' : '#dc2626',
                  color: '#fff'
                }}
              >
                <td>
                  <img
                    className="user-icon m-2"
                    src={`https://vacway-images.s3.eu-central-1.amazonaws.com/${user.fullname}.png`}
                    alt="User"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop in case default also fails
                      e.target.src = "https://vacway-images.s3.eu-central-1.amazonaws.com/default.png"; // Default image if user image fails to load
                    }}
                  />
                </td>
                <td>{user.fullname}</td>
                <td>{user.workingday}h</td>
                <td>{expectedWorkingHours[user.fullname]}</td>
                <td>{totalWorkingHours[user.fullname]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { shifts, promoters, error } = this.props

    if (!shifts || !promoters) {
      return (
        <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    const today = new Date().toLocaleDateString('es-ES', { timeZone: 'UTC', weekday: 'long', day: '2-digit', month: 'long' })
    const activeCount = promoters.filter(p => p.status === 'ALTA').length

    return (
      <div className="machines-admin-view">

        {/* Header */}
        <div className="mach-admin-header od-header-detail">
          <div className="od-header-left">
            <div className="od-header-info">
              <div className="od-header-title">
                <span className="od-header-product">Gestión</span>
                <span className="od-header-serial">Jornadas Promotor</span>
              </div>
              <div className="od-header-meta">
                <span className="od-header-meta-item">
                  <i className="fas fa-users"></i>
                  Promotores activos:&nbsp;<strong>{activeCount}</strong>
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-calendar-day"></i>
                  {today}
                </span>
              </div>
            </div>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <button type="button" className="btn bg-vw-light text-white" onClick={this.toggleAddModal}>
              <i className="fas fa-plus mr-1"></i>Añadir fichaje
            </button>
          </div>
        </div>

        {/* Modal */}
        <Modal isOpen={this.state.addModal} toggle={this.toggleAddModal}>
          <ModalHeader toggle={this.toggleAddModal}>
            <span className="text-vw-dark">NUEVO </span>
            <span className="text-vw-light">FICHAJE</span>
          </ModalHeader>
          <form onSubmit={this.handleAddSubmit}>
            <ModalBody>
              <div className="form-group">
                <label>Trabajador</label>
                <select
                  name="workerName"
                  className="form-control"
                  value={this.state.addForm.workerName}
                  onChange={this.handleAddFormChange}
                >
                  <option value="">Selecciona un trabajador...</option>
                  {promoters && promoters.filter(p => p.status === 'ALTA').map(p => (
                    <option key={p.fullname} value={p.fullname}>{p.fullname}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Acción</label>
                <select
                  name="action"
                  className="form-control"
                  value={this.state.addForm.action}
                  onChange={this.handleAddFormChange}
                >
                  <option value="START">Inicio jornada</option>
                  <option value="STOP">Fin jornada</option>
                </select>
              </div>
              <div className="form-group">
                <label>Fecha y hora</label>
                <input
                  type="datetime-local"
                  name="date"
                  className="form-control"
                  value={this.state.addForm.date}
                  onChange={this.handleAddFormChange}
                />
              </div>
              {this.state.addError && (
                <div className="alert alert-danger">{this.state.addError}</div>
              )}
            </ModalBody>
            <ModalFooter>
              <button type="submit" className="btn bg-vw-light text-white mr-1">
                Añadir
              </button>
              <button type="button" className="btn btn-secondary" onClick={this.toggleAddModal}>
                Cancelar
              </button>
            </ModalFooter>
          </form>
        </Modal>

        {/* Filter */}
        <div style={{
          marginTop: 16,
          padding: 'clamp(14px,3vw,20px)',
          backgroundColor: '#f8fafc',
          borderRadius: 12,
          border: '1px solid #e2e8f0'
        }}>
          <h4 style={{ margin: '0 0 14px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fas fa-filter" style={{ color: '#0a4080' }}></i>
            Filtro
          </h4>
          <ShiftsFilterForm />
        </div>

        {/* Jornada + Cómputo */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,480px),1fr))', gap: 16, marginTop: 16 }}>

          <div style={{
            padding: 'clamp(14px,3vw,20px)',
            backgroundColor: '#f8fafc',
            borderRadius: 12,
            border: '1px solid #e2e8f0'
          }}>
            <h4 style={{ margin: '0 0 14px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <i className="fas fa-calendar" style={{ color: '#0a4080' }}></i>
              Jornada
            </h4>
            {this.renderWorkers()}
          </div>

          <div style={{
            padding: 'clamp(14px,3vw,20px)',
            backgroundColor: '#f8fafc',
            borderRadius: 12,
            border: '1px solid #e2e8f0'
          }}>
            <h4 style={{ margin: '0 0 14px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <i className="fas fa-chart-bar" style={{ color: '#0a4080' }}></i>
              Cómputo horas
            </h4>
            {this.renderTotalWorkers()}
          </div>

        </div>

        {/* Registros */}
        <div style={{
          marginTop: 16,
          marginBottom: 20,
          padding: 'clamp(14px,3vw,20px)',
          backgroundColor: '#f8fafc',
          borderRadius: 12,
          border: '1px solid #e2e8f0'
        }}>
          <h4 style={{ margin: '0 0 14px', color: '#1e293b', fontWeight: 700, fontSize: 'clamp(0.95rem,2vw,1.05rem)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fas fa-list" style={{ color: '#0a4080' }}></i>
            Registros
          </h4>
          {this.renderShifts()}
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  shifts: state.shifts.shifts,
  promoters: state.promoters.promoters,
  form: state.form,
  filteredPromoters: state.promoters.filteredPromoters,
  shiftdaysPromoters: state.promoters.shiftdaysPromoters
})

const mapDispatchToProps = dispatch => ({
  fetchShifts: bindActionCreators(fetchShifts, dispatch),
  fetchPromoters: bindActionCreators(fetchPromoters, dispatch),
  addShiftPromoter: bindActionCreators(addShiftPromoter, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ShiftsView)


